import React from 'react';

export default function Footer() {
  return (
    <footer style={{ padding: '1rem 16rem', background: 'var(--polynesian-blue)', color: 'white', textAlign: 'center' }}>
      © 2025 Raymond Xu. All rights reserved.
    </footer>
  );
}
